import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { DataGridPremium, useGridApiRef } from '@mui/x-data-grid-premium'
import { CardPartner } from 'api/swagger/definitions/backoffice'
import { CoreMyntModal } from 'components/modals/CoreMyntModal'
import { prettifyEnumLabel } from 'helpers/CreditOnCardHelpers'
import { useEffect, useState } from 'react'
import { mcc, mid, useCategories, useRule } from './adapters'
import { type DataTable, type Modal, SpendControlTable } from './SpendControlTable'

export const SpendConrolTableInjected = () => {
  const [partner, setPartner] = useState<string | undefined>(CardPartner.DEHAAN)

  const partnerOptions = Object.values(CardPartner)
    .map((partner) => ({ value: partner, label: prettifyEnumLabel(partner) }))
    .sort((a, b) => a.value.localeCompare(b.value))

  return (
    <Box display="flex" flexDirection="column" padding={4} paddingLeft={6} paddingRight={6} gap={2}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h2">Spend control categories</Typography>
        <FormControl>
          <InputLabel id="card-partner">Card partner</InputLabel>
          <Select
            labelId="card-partner"
            id="card-partner"
            value={partner}
            label="Card partner"
            onChange={(event) => setPartner(event.target.value)}
          >
            {partnerOptions.map(({ label, value }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <SpendControlTable
        slots={{ Table: DataTableComponent, Modal: ModalComponent }}
        useCategories={useCategories}
        parsers={{ mcc, mid }}
        useRule={useRule}
        partner={partner}
      />
    </Box>
  )
}

const DataTableComponent: DataTable = ({ columns, loading, onRowClick, rows }) => {
  const apiRef = useGridApiRef()

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore existing biome errors
  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore existing biome errors
  useEffect(() => {
    apiRef.current?.autosizeColumns({ includeOutliers: true })
  }, [rows, loading])

  return (
    <Box>
      <DataGridPremium
        sx={{ '.MuiDataGrid-row': { cursor: 'pointer' } }}
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        disableRowSelectionOnClick
        onRowClick={({ row }) => onRowClick(row)}
        slots={{ noResultsOverlay: () => <Typography>No results, make sure you have selected a partner</Typography> }}
      />
    </Box>
  )
}

const ModalComponent: Modal = ({ open, heading, onRequestClose, children }) => {
  return (
    <CoreMyntModal wrapperProps={{ style: { minWidth: 550 } }} title={heading} onClose={onRequestClose} actions={() => null} open={open}>
      <Box>{children}</Box>
    </CoreMyntModal>
  )
}
